import { render, staticRenderFns } from "./QrScudButton.vue?vue&type=template&id=38cfb8ab&"
import script from "./QrScudButton.vue?vue&type=script&lang=js&"
export * from "./QrScudButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports